import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const MentionsLegales = () => {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Mentions Legales</h1>
        <p>Informations legales obligatoires</p>
      </div>

      <div className="legal-content">
        <Link to="/" className="legal-back-link">
          ← Retour a l'accueil
        </Link>

        <div className="legal-section">
          <h2>1. Editeur du site</h2>
          <div className="legal-info-box">
            <p><strong>Nom de l'entreprise :</strong> STREET DRIVE MARKET</p>
            <p><strong>Nom commercial :</strong> F12IA</p>
            <p><strong>Forme juridique :</strong> SAS (Societe par actions simplifiee)</p>
            <p><strong>Capital social :</strong> 1 000,00 EUR</p>
            <p><strong>Siege social :</strong> 2 Allee des Pins, 30000 Nimes, France</p>
            <p><strong>SIREN :</strong> 914 635 495</p>
            <p><strong>SIRET :</strong> 914 635 495 00023</p>
            <p><strong>RCS :</strong> Nimes B 914 635 495</p>
            <p><strong>Numero de TVA intracommunautaire :</strong> FR82914635495</p>
            <p><strong>Email :</strong> contact@f12ia.com</p>
            <p><strong>Directeur de la publication :</strong> Le President de la SAS STREET DRIVE MARKET</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>2. Hebergeur</h2>
          <div className="legal-info-box">
            <p><strong>Nom :</strong> Vercel Inc.</p>
            <p><strong>Adresse :</strong> 340 S Lemon Ave #4133, Walnut, CA 91789, USA</p>
            <p><strong>Site web :</strong> vercel.com</p>
          </div>
          <p>
            Les donnees sont hebergees dans des centres de donnees securises conformes aux
            normes internationales de securite.
          </p>
        </div>

        <div className="legal-section">
          <h2>3. Activite</h2>
          <p>
            Le site f12ia.com est un site de vente de formations en ligne dans le domaine
            de l'intelligence artificielle. L'activite principale est la creation et la
            commercialisation de contenus pedagogiques numeriques.
          </p>
          <p>
            <strong>Code NAF/APE :</strong> 8559A - Formation continue d'adultes
          </p>
        </div>

        <div className="legal-section">
          <h2>4. Propriete intellectuelle</h2>
          <p>
            L'ensemble du contenu du site F12IA (textes, images, videos, logos, icones,
            sons, logiciels, base de donnees, structure, etc.) est protege par le droit
            d'auteur (articles L111-1 et suivants du Code de la propriete intellectuelle)
            et le droit des marques.
          </p>
          <p>
            La marque F12IA, son logo et l'ensemble des elements graphiques associes sont
            des marques deposees. Toute utilisation, reproduction ou representation non
            autorisee de ces elements est strictement interdite et constitue un acte de
            contrefacon puni par les articles L335-2 et suivants du Code de la propriete
            intellectuelle.
          </p>
          <p>
            <strong>Sanctions encourues :</strong> Jusqu'a 3 ans d'emprisonnement et
            300 000 EUR d'amende (personnes physiques), 1 500 000 EUR pour les personnes
            morales.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Conditions d'utilisation du site</h2>
          <p>
            L'utilisation du site f12ia.com implique l'acceptation pleine et entiere des
            conditions generales d'utilisation ci-apres decrites.
          </p>
          <p>
            <strong>L'utilisateur s'interdit notamment de :</strong>
          </p>
          <ul>
            <li>Utiliser le site a des fins illegales ou non autorisees</li>
            <li>Tenter d'acceder a des zones non autorisees du site ou des serveurs</li>
            <li>Perturber le fonctionnement du site (attaques DDoS, injection, etc.)</li>
            <li>Collecter des informations sur les autres utilisateurs sans autorisation</li>
            <li>Utiliser des robots, spiders ou autres outils automatises</li>
            <li>Reproduire, copier ou exploiter le contenu du site</li>
          </ul>
          <p>
            Tout manquement a ces conditions peut entrainer la suspension de l'acces au site
            et/ou des poursuites judiciaires.
          </p>
        </div>

        <div className="legal-section">
          <h2>6. Limitation de responsabilite</h2>
          <p>
            F12IA s'efforce de fournir des informations aussi precises que possible sur le site.
            Toutefois, F12IA ne pourra etre tenu responsable :
          </p>
          <ul>
            <li>Des omissions, inexactitudes ou carences dans la mise a jour des informations</li>
            <li>Des dommages directs ou indirects resultant de l'acces ou de l'utilisation du site</li>
            <li>Des interruptions ou dysfonctionnements du site</li>
            <li>De l'impossibilite d'utiliser le site</li>
            <li>De l'utilisation frauduleuse du site par des tiers</li>
            <li>Des virus ou autres elements nuisibles</li>
          </ul>
          <p>
            L'utilisateur est seul responsable de l'utilisation qu'il fait du site et des
            informations qu'il y trouve.
          </p>
        </div>

        <div className="legal-section">
          <h2>7. Liens hypertextes</h2>
          <p>
            Le site F12IA peut contenir des liens hypertextes vers d'autres sites internet.
            F12IA n'exerce aucun controle sur ces sites externes et decline toute responsabilite
            quant a leur contenu, leurs pratiques en matiere de protection des donnees et
            leur conformite a la reglementation.
          </p>
          <p>
            La creation de liens hypertextes vers le site f12ia.com est soumise a autorisation
            prealable ecrite de F12IA. Toute demande doit etre adressee a contact@f12ia.com.
          </p>
        </div>

        <div className="legal-section">
          <h2>8. Cookies et traceurs</h2>
          <p>
            Le site F12IA utilise des cookies pour ameliorer l'experience utilisateur et
            mesurer l'audience du site. Conformement a la reglementation, l'utilisateur est
            informe de l'utilisation de cookies et peut les accepter ou les refuser.
          </p>
          <p>
            Pour plus d'informations sur l'utilisation des cookies, veuillez consulter
            notre <Link to="/politique-confidentialite">Politique de Confidentialite</Link>.
          </p>
        </div>

        <div className="legal-section">
          <h2>9. Protection des donnees personnelles</h2>
          <p>
            Conformement au Reglement General sur la Protection des Donnees (RGPD) et a la
            loi Informatique et Libertes du 6 janvier 1978 modifiee, F12IA s'engage a
            proteger les donnees personnelles de ses utilisateurs.
          </p>
          <p>
            Pour toute information ou exercice de vos droits (acces, rectification, suppression,
            portabilite, limitation, opposition), vous pouvez contacter :
          </p>
          <div className="legal-info-box">
            <p><strong>Email :</strong> contact@f12ia.com</p>
            <p><strong>Objet :</strong> Demande relative aux donnees personnelles</p>
          </div>
          <p>
            Pour plus de details, consultez notre{' '}
            <Link to="/politique-confidentialite">Politique de Confidentialite</Link>.
          </p>
        </div>

        <div className="legal-section">
          <h2>10. Securite</h2>
          <p>
            F12IA met en oeuvre des mesures techniques et organisationnelles pour assurer
            la securite du site et des donnees :
          </p>
          <ul>
            <li>Chiffrement SSL/TLS (HTTPS) pour toutes les communications</li>
            <li>Protection contre les attaques courantes (XSS, CSRF, injection SQL)</li>
            <li>Stockage securise des mots de passe (hashage bcrypt)</li>
            <li>Sauvegardes regulieres des donnees</li>
            <li>Surveillance et detection des intrusions</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>11. Droit applicable et juridiction</h2>
          <p>
            Les presentes mentions legales sont soumises au droit francais.
          </p>
          <p>
            En cas de litige relatif a l'utilisation du site, et a defaut de resolution amiable,
            les tribunaux francais du ressort de la Cour d'appel de Nimes seront seuls competents.
          </p>
        </div>

        <div className="legal-section">
          <h2>12. Credits</h2>
          <p>
            <strong>Conception et developpement :</strong> F12IA
          </p>
          <p>
            <strong>Technologies utilisees :</strong> React, Node.js, Firebase
          </p>
        </div>

        <p className="legal-update-date">
          Derniere mise a jour : Janvier 2025
        </p>
      </div>
    </div>
  );
};

export default MentionsLegales;
